import React from 'react'

interface Code extends React.HTMLProps<HTMLElement> {
  isHeader?: boolean
  node?: any
}

const Code: React.FC<Code> = ({ children, isHeader, node, ...props }) => {
  return (
    <code className="text-primary-900 dark:text-primary-200" {...props}>
      {children}
    </code>
  )
}

export default Code
